export default __webpack_public_path__ + "static/media/artists1.a926f7bd.jpeg";